import React, { useMemo, useState } from 'react';
import { ELEMENT_CATEGORIES } from '../../data/elementsCatalog';
import ElementTile from './ElementTile';

const chips = [
  { id: 'shape', label: 'Shape' },
  { id: 'line', label: 'Line' },
  { id: 'frame', label: 'Frame' },
  { id: 'arrow', label: 'Arrow' },
];

const ElementsHome = ({
  query,
  onQueryChange,
  activeChip,
  onChipClick,
  onSelectCategory,
  recentItems,
  onActivateItem,
}) => {
  const [generateOpen, setGenerateOpen] = useState(false);
  const recentList = useMemo(() => (recentItems || []).slice(0, 12), [recentItems]);

  return (
    <div className="elements-home">
      <div className="elements-search">
        <span className="elements-search-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" strokeWidth="1.6">
            <circle cx="11" cy="11" r="7" />
            <path d="M16.5 16.5L21 21" />
          </svg>
        </span>
        <input
          type="text"
          placeholder="Search elements"
          value={query}
          onChange={(event) => onQueryChange(event.target.value)}
        />
        <span className="elements-search-actions" aria-hidden="true">
          <button type="button" className="elements-search-action" tabIndex={-1}>
            <svg viewBox="0 0 24 24" fill="none" strokeWidth="1.5">
              <path d="M12 3v10" />
              <circle cx="12" cy="17" r="4" />
            </svg>
          </button>
          <button type="button" className="elements-search-action" tabIndex={-1}>
            <svg viewBox="0 0 24 24" fill="none" strokeWidth="1.5">
              <path d="M8 5l8 7-8 7" />
            </svg>
          </button>
        </span>
      </div>

      <div className="elements-chip-row" role="list">
        {chips.map((chip) => (
          <button
            key={chip.id}
            type="button"
            className={`elements-chip ${activeChip === chip.id ? 'active' : ''}`}
            onClick={() => onChipClick(chip.id)}
          >
            {chip.label}
          </button>
        ))}
      </div>

      <button
        type="button"
        className={`elements-generate ${generateOpen ? 'open' : ''}`}
        onClick={() => setGenerateOpen((prev) => !prev)}
        aria-expanded={generateOpen}
      >
        <span className="elements-generate-icon" aria-hidden="true">*</span>
        <span>Generate images</span>
        <span className="elements-generate-chevron" aria-hidden="true">&gt;</span>
      </button>
      {generateOpen && (
        <div className="elements-generate-panel">
          Coming soon.
        </div>
      )}

      <div className="elements-section">
        <div className="elements-section-header">
          <span>Recently used</span>
          <button
            type="button"
            className="elements-link"
            onClick={() => onSelectCategory({ id: 'recent', title: 'Recently used' })}
          >
            See all
          </button>
        </div>
        {recentList.length === 0 ? (
          <div className="elements-empty">
            Your recently used elements will appear here.
          </div>
        ) : (
          <div className="elements-recent-grid elements-grid" role="list">
            {recentList.map((item) => (
              <ElementTile
                key={item.catalogId}
                item={item}
                onActivate={onActivateItem}
                size="compact"
              />
            ))}
          </div>
        )}
      </div>

      <div className="elements-section">
        <div className="elements-section-header">
          <span>Browse categories</span>
        </div>
        <div className="elements-category-grid">
          {ELEMENT_CATEGORIES.map((category) => (
            <button
              key={category.id}
              type="button"
              className={`elements-category-tile ${category.disabled ? 'disabled' : ''}`}
              onClick={() => {
                if (!category.disabled) {
                  onSelectCategory({ id: category.id, title: category.title });
                }
              }}
              disabled={category.disabled}
            >
              <div className="elements-category-icon" aria-hidden="true">
                <div className={`elements-icon elements-icon-${category.iconKey}`} />
              </div>
              <span>{category.title}</span>
              {category.disabled && <em>Coming soon</em>}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ElementsHome;
